// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "../EnumHelperFuncs";
export var OTelSpanStatusCode = (/*@__PURE__*/createEnumStyle({
    UNSET: 0 /* eOTelSpanStatusCode.UNSET */,
    OK: 1 /* eOTelSpanStatusCode.OK */,
    ERROR: 2 /* eOTelSpanStatusCode.ERROR */
}));
//# sourceMappingURL=OTelSpanStatus.js.map